var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _SearchAssetModelPropertyListsRequest_instances, _SearchAssetModelPropertyListsRequest_cache, _SearchAssetModelPropertyListsRequest_client, _SearchAssetModelPropertyListsRequest_findAssetModelProperty, _SearchAssetModelPropertyListsRequest_createCommand, _SearchAssetModelPropertyListsRequest_handleError;
import { ListAssetModelPropertiesCommand, } from '@aws-sdk/client-iotsitewise';
export class SearchAssetModelPropertyListsRequest {
    constructor(client) {
        _SearchAssetModelPropertyListsRequest_instances.add(this);
        _SearchAssetModelPropertyListsRequest_cache.set(this, {});
        _SearchAssetModelPropertyListsRequest_client.set(this, void 0);
        __classPrivateFieldSet(this, _SearchAssetModelPropertyListsRequest_client, client, "f");
    }
    async send({ assetModelPropertyId, assetModelId, }) {
        var _a, _b, _c;
        // see if asset model property is cached
        if ((_a = __classPrivateFieldGet(this, _SearchAssetModelPropertyListsRequest_cache, "f")[assetModelId]) === null || _a === void 0 ? void 0 : _a.assetModelProperties) {
            const foundAssetModelProperty = __classPrivateFieldGet(this, _SearchAssetModelPropertyListsRequest_instances, "m", _SearchAssetModelPropertyListsRequest_findAssetModelProperty).call(this, {
                assetModelPropertyId,
                assetModelProperties: __classPrivateFieldGet(this, _SearchAssetModelPropertyListsRequest_cache, "f")[assetModelId].assetModelProperties,
            });
            if (foundAssetModelProperty) {
                return foundAssetModelProperty;
            }
        }
        // asset model property does not exist
        if (((_b = __classPrivateFieldGet(this, _SearchAssetModelPropertyListsRequest_cache, "f")[assetModelId]) === null || _b === void 0 ? void 0 : _b.assetModelProperties) &&
            !__classPrivateFieldGet(this, _SearchAssetModelPropertyListsRequest_cache, "f")[assetModelId].nextToken) {
            return undefined;
        }
        try {
            do {
                const command = __classPrivateFieldGet(this, _SearchAssetModelPropertyListsRequest_instances, "m", _SearchAssetModelPropertyListsRequest_createCommand).call(this, {
                    assetModelId,
                    nextToken: (_c = __classPrivateFieldGet(this, _SearchAssetModelPropertyListsRequest_cache, "f")[assetModelId]) === null || _c === void 0 ? void 0 : _c.nextToken,
                });
                const { assetModelPropertySummaries: newAssetModelProperties = [], nextToken: newNextToken, } = await __classPrivateFieldGet(this, _SearchAssetModelPropertyListsRequest_client, "f").send(command);
                if (__classPrivateFieldGet(this, _SearchAssetModelPropertyListsRequest_cache, "f")[assetModelId]) {
                    __classPrivateFieldGet(this, _SearchAssetModelPropertyListsRequest_cache, "f")[assetModelId].assetModelProperties.push(...newAssetModelProperties);
                    __classPrivateFieldGet(this, _SearchAssetModelPropertyListsRequest_cache, "f")[assetModelId].nextToken = newNextToken;
                }
                else {
                    __classPrivateFieldGet(this, _SearchAssetModelPropertyListsRequest_cache, "f")[assetModelId] = {
                        assetModelProperties: newAssetModelProperties,
                        nextToken: newNextToken,
                    };
                }
                const foundAssetModelProperty = __classPrivateFieldGet(this, _SearchAssetModelPropertyListsRequest_instances, "m", _SearchAssetModelPropertyListsRequest_findAssetModelProperty).call(this, {
                    assetModelPropertyId,
                    assetModelProperties: __classPrivateFieldGet(this, _SearchAssetModelPropertyListsRequest_cache, "f")[assetModelId].assetModelProperties,
                });
                if (foundAssetModelProperty) {
                    return foundAssetModelProperty;
                }
            } while (__classPrivateFieldGet(this, _SearchAssetModelPropertyListsRequest_cache, "f")[assetModelId].nextToken);
        }
        catch (error) {
            __classPrivateFieldGet(this, _SearchAssetModelPropertyListsRequest_instances, "m", _SearchAssetModelPropertyListsRequest_handleError).call(this, error);
        }
    }
}
_SearchAssetModelPropertyListsRequest_cache = new WeakMap(), _SearchAssetModelPropertyListsRequest_client = new WeakMap(), _SearchAssetModelPropertyListsRequest_instances = new WeakSet(), _SearchAssetModelPropertyListsRequest_findAssetModelProperty = function _SearchAssetModelPropertyListsRequest_findAssetModelProperty({ assetModelPropertyId, assetModelProperties, }) {
    const assetModelProperty = assetModelProperties.find(({ id }) => id === assetModelPropertyId);
    return assetModelProperty;
}, _SearchAssetModelPropertyListsRequest_createCommand = function _SearchAssetModelPropertyListsRequest_createCommand(input) {
    const FILTER = 'ALL';
    const MAX_RESULTS = 250;
    const command = new ListAssetModelPropertiesCommand({
        ...input,
        filter: FILTER,
        maxResults: MAX_RESULTS,
    });
    return command;
}, _SearchAssetModelPropertyListsRequest_handleError = function _SearchAssetModelPropertyListsRequest_handleError(error) {
    const errorMessage = `Failed to search asset model property lists. Error: ${error}`;
    console.error(errorMessage);
    throw new Error(errorMessage);
};
